<template>
	<div class="c-input-brief-dropdown">
		<label v-if="label" class="form__label" :for="slug">{{ label }}</label>
		<div
			tabindex="1"
			class="c-input-brief-dropdown__input form-control"
			@mouseup="onInputClick($event)"
			ref="popupBoard"
		>
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M16 12V5C16 4.44772 15.5523 4 15 4H4C3.44772 4 3 4.44772 3 5V17.5C3 18.8807 4.11929 20 5.5 20H18.5M16 12V17.5C16 18.8807 17.1193 20 18.5 20M16 12H20C20.5523 12 21 12.4477 21 13V17.5C21 18.8807 19.8807 20 18.5 20M7 16H12M7 8H12V12H7V8Z"
					stroke="currentColor"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>

			<section v-if="currentBrief">
				<span v-if="currentBrief">
					{{ currentBrief.name }}
				</span>
				<i> {{ currentBrief.brandName }} - {{ currentBrief.productName }} </i>
			</section>
		</div>
		<PopupBrief
			placement="bottom"
			v-if="hasMounted"
			:active="active"
			:target="target"
			@onClose="active = false"
		>
			<div
				:class="[
					'c-input-brief-dropdown__item',
					{ active: currentBrief && currentBrief.id === brief.id },
				]"
				v-for="brief in currentBriefs"
				:key="brief.id"
				@click="onBriefClick(brief)"
			>
				<svg
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M16 12V5C16 4.44772 15.5523 4 15 4H4C3.44772 4 3 4.44772 3 5V17.5C3 18.8807 4.11929 20 5.5 20H18.5M16 12V17.5C16 18.8807 17.1193 20 18.5 20M16 12H20C20.5523 12 21 12.4477 21 13V17.5C21 18.8807 19.8807 20 18.5 20M7 16H12M7 8H12V12H7V8Z"
						stroke="currentColor"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
				</svg>
				<section v-if="brief">
					<span v-if="brief">
						{{ brief.name }}
					</span>
					<i> {{ brief.brandName }} - {{ brief.productName }} </i>
				</section>
			</div>
		</PopupBrief>
		<InputError v-if="hasError" :message="errorMessage"></InputError>
		<InputDescription
			v-if="description"
			:message="description"
		></InputDescription>
	</div>
</template>

<script>
import PopupBrief from '@swipekit/components/popup/popup-brief';
import InputError from './input-error';
import InputDescription from './input-description';
import slugify from '@swipekit/lib/slugify.js';

export default {
	components: {
		PopupBrief,
		InputError,
		InputDescription,
	},

	data: function () {
		return {
			hasMounted: false,
			active: false,

			currentBrief: null,
		};
	},

	props: {
		label: {
			type: String,
			default: '',
		},
		validation: {},
		value: {},
		placeholder: {
			type: String,
			default: '',
		},
		noStyle: {
			type: Boolean,
			default: false,
		},
		description: {
			type: String,
			default: '',
		},
		hasError: {
			type: Boolean,
			default: false,
		},
		errorMessage: {},
	},

	watch: {
		value: {
			handler: function () {
				let value = this.value;

				if (!value) {
					if (this.defaultBrief) {
						this.currentBrief = this.defaultBrief;
						return;
					} else {
						this.currentBrief = null;
						return;
					}
				}

				let brief = null;
				let briefs = this.briefs;

				for (let i = 0; i < briefs.length; i++) {
					let f = briefs[i];
					if (f.id === this.value) {
						brief = f;
						break;
					}
				}

				if (brief) {
					this.currentBrief = brief;
				}

				if (!brief) {
					if (this.defaultBrief) {
						this.currentBrief = this.defaultBrief;
					}
				}
			},
			immediate: true,
		},
		currentBriefs: function (newz, old) {
			// this.onChange({
			// 	target: {
			// 		value: this.currentFolders,
			// 	},
			// });
		},
	},

	computed: {
		defaultBrief: function () {
			if (!this.briefs) {
				return;
			}
			let briefs = this.briefs;
			let defaultBrief = null;
			for (let i = 0; i < briefs.length; i++) {
				const f = briefs[i];
				if (f.default) {
					defaultBrief = f;
					break;
				}
			}

			return defaultBrief;
		},
		slug: function () {
			return slugify(this.label || `input_${Math.floor(Math.random() * 100)}`);
		},
		target: function () {
			return this.$refs.popupBoard;
		},
		briefs: function () {
			return this.$store.getters['briefs/filtered'];
		},
		currentBriefs: function () {
			return this.briefs;
		},
	},

	methods: {
		onBriefClick: function (brief) {
			this.currentBrief = brief;
			this.active = false;
			this.$emit('input', brief.id);
		},
		onInputClick: function (e) {
			if (e.target.closest('.c-input-brief-dropdown__input') && this.active) {
				return;
			}

			this.active = !this.active;
		},
		onChange: function (e) {
			let value = e.target.value;
			this.$emit('input', value);
		},
	},

	created: function () {},

	mounted: function () {
		this.hasMounted = true;
	},
};
</script>

<style lang="scss">
.c-input-brief-dropdown {
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding-bottom: var(--margin-lg);
	width: 100%;

	.close {
		font-family: 'icomoon' !important;
		speak: none;
		font-style: normal;
		font-weight: normal;
		font-variant: normal;
		text-transform: none;
		line-height: 1;
		-webkit-font-smoothing: antialiased;
		&:after {
			content: '\e901';
		}
	}

	.c-input-boards {
		padding-bottom: 0;
	}

	.c-popup-brief {
		.c-popup {
			overflow: hidden;
		}
	}

	&__input {
		cursor: pointer;
		display: inline-flex !important;
		padding-left: var(--margin) !important;
		align-items: center;

		svg {
			margin-right: var(--margin);
			min-width: 24px;
		}

		section {
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;

			i {
				font-size: var(--font-size-xs);
				opacity: 0.8;
				font-style: normal;
			}
		}
	}

	&__item {
		padding: var(--margin);
		font-size: var(--font-size-sm);
		display: flex;
		align-items: center;
		cursor: pointer;

		svg {
			margin-right: var(--margin);
			min-width: 24px;
		}

		section {
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;

			i {
				font-size: var(--font-size-xs);
				opacity: 0.8;
				font-style: normal;
			}
		}

		&:hover,
		&:active {
			background-color: var(--color-bg-3);
		}

		&.active {
			background-color: var(--color-primary);
			color: var(--color-button-font);
		}
	}
}
</style>
